import { SVGProps, Ref, forwardRef } from 'react';

export const ZarplataBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14" fill="#FEE305" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.62 11.063V9.867a.24.24 0 0 1 .333-.22c.735.32 1.542.475 2.42.475 1.203 0 1.9-.332 1.9-.918 0-.522-.46-.776-1.393-.776H6.57a.24.24 0 0 1-.241-.241V7.056c0-.134.108-.242.242-.242H7.88c.76 0 1.14-.237 1.14-.696q0-.76-1.615-.76c-.828 0-1.575.128-2.24.394a.237.237 0 0 1-.324-.222V4.39c0-.149.092-.28.23-.335.769-.314 1.719-.47 2.825-.47q1.448 0 2.421.617c.65.411.982.934.982 1.552 0 .808-.328 1.356-.982 1.634-.05.02-.048.095.003.114.743.283 1.295.897 1.295 1.828q0 1.117-1.091 1.852c-.713.476-1.663.713-2.834.713-1.137 0-2.079-.17-2.847-.5a.36.36 0 0 1-.224-.332"
            fill="#251E1E"
        />
    </svg>
));
ZarplataBrandSize16Glyph.displayName = 'ZarplataBrandSize16Glyph';
